/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-17 14:42:42
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-05-19 13:47:15
 * @FilePath: \english_admin\src\assets\css\theme.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// assets/js/theme.js
import { themes } from './model'
// 修改页面中的样式变量值,这里的值是theme.less全局变量中的值，里面的值可以在页面中，任何一个地方使用
const changeStyle = (obj) => {
  for (const key in obj) {
    //修改less中的变量值
    document.getElementsByTagName('body')[0].style.setProperty(`--${key}`, obj[key])
  }
}


// 改变主题的方法
export const setTheme = (themeName) => {
  localStorage.setItem('theme', themeName) // 保存主题到本地，下次进入使用该主题
  const themeConfig = themes[themeName]
  // 如果有主题名称，那么则采用我们定义的主题
  // console.log(themeConfig)
  if (themeConfig) {
    localStorage.setItem('primaryColor', themeConfig.primaryColor) // 保存主题色到本地
    localStorage.setItem('primaryTextColor', themeConfig.primaryTextColor) // 保存文字颜色到本地
    changeStyle(themeConfig) // 改变样式
  } else {
    const themeConfig = {
      primaryColor: localStorage.getItem('primaryColor'),
      primaryTextColor: localStorage.getItem('primaryTextColor')
    }
    changeStyle(themeConfig)
  }
}



// WEBPACK FOOTER //
// ./src/assets/css/theme.js